export interface RepRates {
  [key: string]: {
    startFrom: string
    repAPR: string
  }
}

export const RepRatesBySource: RepRates = {
  default: {
    startFrom: "8.9%",
    repAPR: "18.8%"
  },
  moneysupermarket: {
    startFrom: "8.9%",
    repAPR: "9.9%"
  },
  msm: {
    startFrom: "8.9%",
    repAPR: "9.9%"
  }
}
